import { Box, Center, Heading, SimpleGrid, Stack, Text } from '@chakra-ui/react';

import { CheckboxContainer } from 'formik-chakra-ui';
import CreateProfileButton from '../CreateProfileButton';
import { FormStep } from '../MultiStepForm';

export default function Tools(props: { onSubmit: any; tools:any; handleToolsChange:any; formError: any, validationSchema: any }) {
    const { onSubmit, formError, tools, handleToolsChange, validationSchema } = props;
    const docsAndPresentationsArray: string[] = [
        'Microsoft Word',
        'Microsoft Excel',
        'Microsoft PowerPoint',
        'Google Docs',
        'Google Sheets',
        'Google Slides'
    ];
    const docsAndPresentationColumn = docsAndPresentationsArray.map(function (tool) {
        return (
            <CreateProfileButton
                type="tools"
                name="tools"
                text={tool}
                key={tool}
                onChange={handleToolsChange}
                isChecked={tools.includes(tool)}
            />
        );
    });
    const salesAndMarketingArray: string[] = [
        'Google Analytics',
        'Google Adsense',
        'Salesforce',
        'Marketo',
        'ExactTarget',
        'Pardot',
        'Qualtrics',
        'Hubspot',
        'Constant Contact',
        'Hootsuite',
        'Braze',
        'Shopify',
        'Later',
        'Planoly'
    ];
    const salesAndMarketingColumn = salesAndMarketingArray.map(function (tool) {
        return (
            <CreateProfileButton
                type="tools"
                name="tools"
                text={tool}
                key={tool}
                onChange={handleToolsChange}
                isChecked={tools.includes(tool)}
            />
        );
    });

    const peopleAndOrganizationArray: string[] = [
        'Workday',
        'Asana',
        'Zendesk',
        'Slack',
        'Notion',
        'Greenhouse',
        'Jira',
        'Discord',
        'Telegram'
    ];

    const peopleAndOrganizationColumn = peopleAndOrganizationArray.map(function (tool) {
        return (
            <CreateProfileButton
                type="tools"
                name="tools"
                text={tool}
                key={tool}
                onChange={handleToolsChange}
                isChecked={tools.includes(tool)}
            />
        );
    });

    const web3Array: string[] = [
        'Blockchain',
        'Ethereum',
        'Solana',
        'Cryptography',
        'Solidity',
        'DeFi',
        'DAOs',
        'Web3JS'
    ];

    const web3Column = web3Array.map(function (tool) {
        return (
            <CreateProfileButton
                type="tools"
                name="tools"
                text={tool}
                key={tool}
                onChange={handleToolsChange}
                isChecked={tools.includes(tool)}
            />
        );
    });

    const designAndProductArray: string[] = [
        'Canva',
        'Figma',
        'Adobe InDesign',
        'Adobe Premiere',
        'Adobe Illustrator',
        'Adobe Photoshop',
        'Adobe XD',
        'InVision',
        'Webflow',
        'Bubble.io',
        'Origami',
        'Solidworks',
        'AutoCAD',
        'Axure'
    ];

    const designAndProductToolsColumn = designAndProductArray.map(function (tool) {
        return (
            <CreateProfileButton
                type="tools"
                name="tools"
                text={tool}
                key={tool}
                onChange={handleToolsChange}
                isChecked={tools.includes(tool)}
            />
        );
    });

    const codingLanguagesArray: string[] = [
        'Java',
        'C++',
        'Python',
        'R',
        'Scala',
        'React',
        'HTML',
        'CSS',
        'JavaScript',
        'jQuery',
        'SQL',
        'Oracle',
        'MySQL',
        'MongoDB',
        'Swift',
        'Objective-C',
        'Scratch',
        'Rust'
    ];

    const codingLanguagesArrayColumn = codingLanguagesArray.map(function (tool) {
        return (
            <CreateProfileButton
                type="tools"
                name="tools"
                text={tool}
                key={tool}
                onChange={handleToolsChange}
                isChecked={tools.includes(tool)}
            />
        );
    });

    const dataAndDevelopmentArray: string[] = ['Tableau', 'Github', 'Google Data Studio', 'Domo'];

    const dataAndDevelopmentColumn = dataAndDevelopmentArray.map(function (tool) {
        return (
            <CreateProfileButton
                type="tools"
                name="tools"
                text={tool}
                key={tool}
                onChange={handleToolsChange}
                isChecked={tools.includes(tool)}
            />
        );
    });
    return (
        <FormStep stepName="tools" onSubmit={onSubmit} formError={formError} validationSchema={validationSchema}>
            <Center>
                <Box w="786px">
                    <Stack>
                        <Heading fontSize="32px" fontWeight={800} mb="3">
                            What tools or software have you used?
                        </Heading>
                        <Box>
                            <SimpleGrid
                                columns={2}
                                spacingX="38px"
                                spacingY={3}
                                h="100%"
                                alignSelf="center"
                            >
                                <CheckboxContainer name="careers">
                                    <Box align="right">
                                        <Text
                                            align="left"
                                            fontWeight={800}
                                            fontSize="20px"
                                            lineHeight="28px"
                                            w="350px"
                                        >
                                            Docs & Presentations
                                        </Text>
                                        {docsAndPresentationColumn}
                                        <Text
                                            align="left"
                                            fontWeight={800}
                                            fontSize="20px"
                                            lineHeight="28px"
                                            mt="36px"
                                            w="350px"
                                        >
                                            Sales & Marketing
                                        </Text>
                                        {salesAndMarketingColumn}
                                        <Text
                                            align="left"
                                            fontWeight={800}
                                            fontSize="20px"
                                            lineHeight="28px"
                                            mt="36px"
                                            w="350px"
                                        >
                                            People & Organization
                                        </Text>
                                        {peopleAndOrganizationColumn}
                                        <Text
                                            align="left"
                                            fontWeight={800}
                                            fontSize="20px"
                                            lineHeight="28px"
                                            mt="36px"
                                            w="350px"
                                        >
                                            Web3
                                        </Text>
                                        {web3Column}
                                    </Box>
                                </CheckboxContainer>
                                <CheckboxContainer
                                    name="careers"
                                    h="48px"
                                    alignItems="left"
                                    ml="-24px"
                                >
                                    <Box align="left">
                                        <Text
                                            align="left"
                                            fontWeight={800}
                                            fontSize="20px"
                                            lineHeight="28px"
                                            w="350px"
                                        >
                                            Product & Design
                                        </Text>
                                        {designAndProductToolsColumn}
                                        <Text
                                            align="left"
                                            fontWeight={800}
                                            fontSize="20px"
                                            lineHeight="28px"
                                            mt="36px"
                                            w="350px"
                                        >
                                            Coding Languages
                                        </Text>
                                        {codingLanguagesArrayColumn}
                                        <Text
                                            align="left"
                                            fontWeight={800}
                                            fontSize="20px"
                                            lineHeight="28px"
                                            mt="36px"
                                            w="350px"
                                        >
                                            Data & Development
                                        </Text>
                                        {dataAndDevelopmentColumn}
                                    </Box>
                                </CheckboxContainer>
                            </SimpleGrid>
                        </Box>
                    </Stack>
                </Box>
            </Center>
        </FormStep>
    );
}
